'use client'

import { Button, ButtonProps } from 'flowbite-react'
import StyledSpinner from "app/components/StyledSpinner";
import { PropsWithChildren } from 'react';
import { useFormStatus } from 'react-dom'

type SubmitButtonProps = {
  text?: string
} & ButtonProps;

export function SubmitButton({text, disabled, children, ...props} : PropsWithChildren<SubmitButtonProps>) {
  const { pending } = useFormStatus();

  return (
    <Button type="submit" disabled={pending||disabled} aria-disabled={pending||disabled} {...props}>
      {text}
      {children}
      {pending ? <StyledSpinner className="mx-2" /> : <></>}
    </Button>
  )
}